import React from 'react';
import EventCategoryLayout from '../../components/EventCategoryLayout';

const CorporateEvents = () => {
  return <EventCategoryLayout categoryId="corporate" />;
};

export default CorporateEvents;
